export enum AssetType {
  Accounts = 'Accounts',
  OtherAssets = 'Other Assets',
  EquityCompensation = 'Equity Compensation',
}

export interface SelectedAsset {
  assetType: AssetType;
  isSimulated: boolean;
}
